const DEBUG = false;
(async function(){
    const href = window.location.href;
    let match_found = false;
    const updateIndicatorLabel = async (topic) => {
        if(match_found) return;

        const indicator = document.querySelector('[data-404-fetch-progress-indicator]');

        if(indicator) {
            const topics = indicator.querySelectorAll('[data-404-fetch-progress-indicator-topic]')
            const topicElement = indicator.querySelector(`[data-404-fetch-progress-indicator-topic="${topic}"]`);

            if(topicElement) {
                topics.forEach(t => {
                    t.style= "";
                });
                topicElement.style = 'display: inline;';
            }
        }

        await window.setTimeout(function(){
            console.log('Fetching ' + topic + '...');
        }, 1000);
    }

    const activateIndicatorLabel = async function() {
        const indicator = document.querySelector('[data-404-fetch-progress-indicator]');

        if(indicator) {
            indicator.setAttribute('data-404-fetch-progress-indicator', 'active');
        }

        return window.setTimeout(function(){}, 800);
    }

    if(href) {
        let url_pieces = href.split('?')[0].split('/');
        const final_path = url_pieces[url_pieces.length - 1];
        const final_path_pieces = final_path.split('-');
        const genders = ['woman', 'women', 'man', 'men'];
        const url_options = {
            path_array: final_path_pieces,
        };

        const store_root = (typeof Shopify !== 'undefined') && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

        const fetch_options = { cache: 'no-store' };

        const vendorCheckAndRedirect = async (possible_vendors, gender = false) => {
            const gender_path = gender ? `/${gender}` : '';

            for (let i = 0; i < possible_vendors.length; i++) {
                const possible_vendor = possible_vendors[i];
                const fetch_path = `${store_root}collections/${possible_vendor}${gender_path}`;

                await fetch(`${fetch_path}.json`, fetch_options)
                .then(res => {
                    if(res.status === 200) {
                        console.log('VENDOR FALLBACK FOUND!');
                        match_found = true;
                        if(!DEBUG) window.location.href = fetch_path;
                    }
                });
            }
        }

        await activateIndicatorLabel();

        /*
        * GENDER CHECKS *
        */
        if(final_path_pieces.includes('women') || final_path_pieces.includes('woman')) {
            url_options['path_array_no_gender'] = final_path_pieces.filter(path_piece => !genders.includes(path_piece));
            url_options['gender'] = 'women';
        } else if(final_path_pieces.includes('men') || final_path_pieces.includes('man')) {
            url_options['path_array_no_gender'] = final_path_pieces.filter(path_piece => !genders.includes(path_piece));
            url_options['gender'] = 'men';
        }

        /*
        * VENDOR CHECKS *
        */
       await updateIndicatorLabel('vendor');
        if(url_options.gender) {
            const possible_vendors = [
                url_options.path_array_no_gender[0],
                [url_options.path_array_no_gender[0], url_options.path_array_no_gender[1]].join('-'),
                [url_options.path_array_no_gender[0], url_options.path_array_no_gender[1], url_options.path_array_no_gender[2]].join('-')
            ];

            await vendorCheckAndRedirect(possible_vendors, url_options.gender);
        } else {
            const possible_vendors = [
                url_options.path_array[0],
                [url_options.path_array[0], url_options.path_array[1]].join('-'),
                [url_options.path_array[0], url_options.path_array[1], url_options.path_array[2]].join('-')
            ];

            await vendorCheckAndRedirect(possible_vendors);
        }

        /*
        * GENDER FALLBACK *
        */
       if(match_found) return;

       await updateIndicatorLabel('gender');
       if(url_options.gender) {
        const fetch_path = `${store_root}collections/${url_options.gender}`;
        await fetch(`${fetch_path}.json`, fetch_options)
        .then(res => {
            if(res.status === 200) {
                console.log('GENDER FALLBACK FOUND');
                match_found = true;
                if(!DEBUG) window.location.href = fetch_path;
            }
        });
       }

       /*
       * NO MATCHES FOUND FALLBACK
       */
      if(match_found) return;
      await updateIndicatorLabel('fallback');
      if(!DEBUG) window.location.href = `${store_root}collections/all`;
    }
})();